import { render, staticRenderFns } from "./OrderByCategory.vue?vue&type=template&id=309055c0&scoped=true&"
import script from "./OrderByCategory.vue?vue&type=script&lang=js&"
export * from "./OrderByCategory.vue?vue&type=script&lang=js&"
import style0 from "./OrderByCategory.vue?vue&type=style&index=0&id=309055c0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "309055c0",
  null
  
)

export default component.exports